/* global axios */
import ApiClient from './ApiClient';

/**
 * SurveyResponsesAPI — answers collected across every survey form.
 *
 * The API never returns a full response token: it is the customer's access
 * credential for the public page, so only a short suffix is exposed for
 * support/debugging.
 */
class SurveyResponsesAPI extends ApiClient {
  constructor() {
    super('survey_responses', { accountScoped: true });
  }

  metrics(params = {}) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  download(params = {}) {
    return axios.get(`${this.url}/download`, { params, responseType: 'blob' });
  }
}

export default new SurveyResponsesAPI();
